<template>
  <img src="/images/logo.png" class="fill-white" width="120" />
</template>
